export const myApplicationsInitialValues = {
  title: '',
  administrative_unit_id: '',
  status: ''
};